import { useState } from 'react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { colors } from '../../employees/styles/personalakteStyles';
import FormConfigEditor from './FormConfigEditor';
import InterviewTemplateEditor from './InterviewTemplateEditor';
import RecruitingPipelineEditor from './RecruitingPipelineEditor';

type SettingsTab = 'form' | 'interviews' | 'pipeline';

export default function RecruitingSettings(): React.JSX.Element {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<SettingsTab>('form');

  const tabStyle = (isActive: boolean): React.CSSProperties => ({
    padding: '8px 16px',
    border: isActive ? '1px solid rgba(82, 113, 165, 0.3)' : '1px solid transparent',
    background: isActive ? 'rgba(82, 113, 165, 0.12)' : 'transparent',
    color: isActive ? '#5271A5' : '#64748b',
    borderRadius: 9999,
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    transition: 'all 0.15s',
  });

  return (
    <div style={{ padding: 16, fontFamily: 'Inter, system-ui, sans-serif', fontSize: '0.9rem' }}>
      <button
        onClick={() => navigate('/employees/recruiting')}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          background: 'none', border: 'none', cursor: 'pointer',
          color: colors.slate, fontSize: 13, fontWeight: 500, marginBottom: 16, padding: 0,
        }}
      >
        <FaArrowLeft style={{ fontSize: 11 }} /> Zurück zur Bewerberliste
      </button>

      <div
        className="glass-header"
        style={{ padding: '12px 16px', marginBottom: 16 }}
      >
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={() => setActiveTab('form')} style={tabStyle(activeTab === 'form')}>
            Bewerbungsformular
          </button>
          <button onClick={() => setActiveTab('interviews')} style={tabStyle(activeTab === 'interviews')}>
            Interview-Templates
          </button>
          <button onClick={() => setActiveTab('pipeline')} style={tabStyle(activeTab === 'pipeline')}>
            Prozesse & Fragen
          </button>
        </div>
      </div>

      {activeTab === 'form' && <FormConfigEditor />}
      {activeTab === 'interviews' && <InterviewTemplateEditor />}
      {activeTab === 'pipeline' && <RecruitingPipelineEditor />}
    </div>
  );
}
